import React from "react";
import { useMediaQuery } from "@mui/material";

export const useIsMobile = () => {
  return useMediaQuery("(max-width:1040px)");
};
